import React from "react";

export default ({ classes, fullscreen }) =>
    <div className={ "m-loader" + (classes ? " " + classes : "") + (fullscreen ? " m-loader--fullscreen" : "") }>
        <div className="m-loader__ring"/>
        <div className="m-loader__ring m-loader__ring--outer"/>
    </div>;
